import { FormulaParser } from '@datapolarna/formulaparser';
import { createLanguage, type FormulaLanguageDescription } from './formulaLanguage';

export const formulaParser = new FormulaParser();
formulaParser.addDefaultFunctions();

const languageDescription: FormulaLanguageDescription = {
  variables: [
    { name: 'index', details: 'Number', info: 'Index of the storage place' },
    { name: 'disabled', details: 'Boolean', info: 'Whether the place is disabled' },
    { name: 'occupied', details: 'Boolean', info: 'Whether the place is occupied' },
    { name: 'packageCount', details: 'Number', info: 'Number of packages in the place' },
    { name: 'maxStackCount', details: 'Number', info: 'Maximum stack count of the place' },
    { name: 'maxWeight', details: 'Number', info: 'Maximum weight of the place' },
    { name: 'maxHeight', details: 'Number', info: 'Maximum height of the place in millimeters' },
    { name: 'x', details: 'Number', info: 'X position in millimeters' },
    { name: 'y', details: 'Number', info: 'Y position in millimeters' },
    { name: 'length', details: 'Number', info: 'Length in millimeters' },
    { name: 'width', details: 'Number', info: 'Width in millimeters' },
    { name: 'zIndex', details: 'Number', info: 'Stacking level of the place' },
    {
      name: 'accessDirections',
      details: 'Number',
      info: 'Bit flags for pickup directions (front=1, right=2, back=4, left=8)',
    },
    { name: 'accessFront', details: 'Boolean', info: 'Whether pickup from front is allowed' },
    { name: 'accessRight', details: 'Boolean', info: 'Whether pickup from right is allowed' },
    { name: 'accessBack', details: 'Boolean', info: 'Whether pickup from back is allowed' },
    { name: 'accessLeft', details: 'Boolean', info: 'Whether pickup from left is allowed' },
    {
      name: 'storageArea',
      children: [
        { name: 'id', details: 'Number', info: 'Id of storage area' },
        { name: 'name', details: 'String', info: 'Name of storage area' },
        { name: 'empty', details: 'Boolean', info: 'Whether storage area is empty' },
      ],
    },
    { name: 'packageId', details: 'String', info: 'Package id' },
    { name: 'packageNumber', details: 'String', info: 'Package number' },
    { name: 'packageTypeId', details: 'String', info: 'Package type id' },
    { name: 'packagingId', details: 'String', info: 'Packaging id' },
    { name: 'productId', details: 'String', info: 'Product id' },
    { name: 'weight', details: 'Number', info: 'Package weight' },
    { name: 'height', details: 'Number', info: 'Package height in millimeters' },
    { name: 'stackLevel', details: 'Number', info: 'Package stack level' },
  ],
};

export const language = createLanguage(formulaParser, languageDescription);
